import React from "react";
import { NavLink } from "react-router-dom";
import {
  HomeOutlined,
  HomeFilled,
  HeartOutlined,
  HeartFilled,
  CalendarOutlined,
  CalendarFilled,
  PhoneOutlined,
  PhoneFilled,
} from "@ant-design/icons";

import "./bottom-tab-bar.component.styles.scss";
import { trackEvent } from "../../../lib/analytics";
import { useLang } from "../../../lib/i18n";

interface Tab {
  to: string;
  labelIt: string;
  labelEn: string;
  Icon: React.ComponentType;
  IconActive: React.ComponentType;
  end?: boolean;
}

const tabs: Tab[] = [
  { to: "/", labelIt: "Home", labelEn: "Home", Icon: HomeOutlined, IconActive: HomeFilled, end: true },
  { to: "/treatments", labelIt: "Rituali", labelEn: "Rituals", Icon: HeartOutlined, IconActive: HeartFilled },
  { to: "/booking", labelIt: "Prenota", labelEn: "Book", Icon: CalendarOutlined, IconActive: CalendarFilled },
  { to: "/contact", labelIt: "Contatti", labelEn: "Contact", Icon: PhoneOutlined, IconActive: PhoneFilled },
];

const BottomTabBar: React.FC = () => {
  const { lang, lp } = useLang();
  const ariaLabel = lang === "en" ? "Main navigation" : "Navigazione principale";
  return (
    <nav className="lvs-tabbar" aria-label={ariaLabel}>
      <div className="lvs-tabbar__rail">
        {tabs.map(({ to, labelIt, labelEn, Icon, IconActive, end }) => {
          const localizedTo = lp(to);
          const label = lang === "en" ? labelEn : labelIt;
          return (
            <NavLink
              key={to}
              to={localizedTo}
              end={end}
              onClick={() =>
                trackEvent("nav_click", { nav_source: "bottom_tab", destination: localizedTo })
              }
              className={({ isActive }) =>
                `lvs-tabbar__item${isActive ? " is-active" : ""}`
              }
            >
              {({ isActive }) => (
                <>
                  <span className="lvs-tabbar__ico" aria-hidden="true">
                    {isActive ? <IconActive /> : <Icon />}
                  </span>
                  <span className="lvs-tabbar__label">{label}</span>
                  <span className="lvs-tabbar__dot" aria-hidden="true" />
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomTabBar;
